import React from 'react';
import { Flex } from '@withjoy/joykit';
import { Coordinates, ListingWithPricing } from '@apps/accommodations/AccommodationsConsole.types';
import { AccommodationsConsoleState } from '@apps/accommodations/AccommodationsConsole.types';
import { TravelLogistics } from './TravelLogistics';
import { CostBreakdown } from './CostBreakdown';
import { ListingPhotos } from './ListingPhotos';
import { HeaderBlock } from './HeaderBlock';
import { HotelCTA } from './HotelCTA';

const Container = ({ children }: { children: React.ReactNode }) => {
  return <Flex columnGap={4}>{children}</Flex>;
};

const ContentPanel = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex flexDirection="column" width="100%">
      {children}
    </Flex>
  );
};

const LogisticsAndCostBlock = ({ children }: { children: React.ReactNode }) => {
  return (
    <Flex flexDirection="row" marginTop={6} justifyContent="space-between" alignItems="center">
      {children}
    </Flex>
  );
};

// TODO:
// - use translation values
const ListingEntry = (props: {
  venueCoordinates: Coordinates;
  listing: ListingWithPricing;
  isLoadingPrices: boolean;
  occupancies: AccommodationsConsoleState['occupancies'];
  noOfNights: number;
}) => {
  const { listing, venueCoordinates, isLoadingPrices, occupancies, noOfNights } = props;
  return (
    <Container>
      <ListingPhotos listing={listing} />

      <ContentPanel>
        <HeaderBlock listing={listing} />
        <LogisticsAndCostBlock>
          <TravelLogistics venueCoordinates={venueCoordinates} listing={listing} />

          <Flex flexDirection={'column'} gap={5}>
            {isLoadingPrices ? (
              <CostBreakdown.Skeleton />
            ) : listing.pricingInfo ? (
              <CostBreakdown occupancies={occupancies} pricingInfo={listing.pricingInfo} noOfNights={noOfNights} />
            ) : null}
            <HotelCTA joyPlaceId={listing.joyPlaceId} hotelName={listing.name} />
          </Flex>
        </LogisticsAndCostBlock>
      </ContentPanel>
    </Container>
  );
};

ListingEntry.Skeleton = () => {
  return (
    <Container>
      <ListingPhotos.Skeleton />
      <ContentPanel>
        <HeaderBlock.Skeleton />

        <LogisticsAndCostBlock>
          <TravelLogistics.Skeleton />
          <CostBreakdown.Skeleton />
        </LogisticsAndCostBlock>
      </ContentPanel>
    </Container>
  );
};

export { ListingEntry };
